import beautyLounge from '@/assets/img/users-cases/beauty-lounge.webp';
import beautyLoungeHow from '@/assets/img/users-cases/beauty-lounge-how.webp';
import beautyLoungeResult from '@/assets/img/users-cases/beauty-lounge-result.webp';

export default {
  slug: 'beauty-lounge',
  order: 15,
  title: '3D Beauty Lounge Interior',
  subtitle: 'Beauty interiors presented in polished 3D renderings',
  tags: ['commercialSpace', 'beautystudio'],

  images: {
    hero: beautyLounge,
    aboutTop: beautyLoungeHow,
    aboutBottom: beautyLoungeResult,
  },

  howText:
    'We created beauty lounge floor plan, 2D and 3D layouts, and interior design for beauty lounge with ergonomics, aesthetics, and lighting.',

  resultText:
    'Clients receive ready visualizations and plans for marketing, investor presentations, and efficient salon openings.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
